var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPickerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.492,
    height: 22.648,
    viewBox: "0 0 17.492 22.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "colorPickerIcon",
    transform: "translate(-14 -3.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11333",
    "data-name": "Path 11333",
    d: "M37.049,4.737,36.005,3.694a1.48,1.48,0,0,0-2.063,0L32.219,5.417,30.666,3.864a.967.967,0,0,0-1.383,0L27.9,5.247a.958.958,0,0,0-.291.68.918.918,0,0,0,.291.68l1.019,1.019L23.094,13.45a2.916,2.916,0,0,0-.68,3.082l-.194.194a1.226,1.226,0,0,0,.849,2.087,1.138,1.138,0,0,0,.849-.364l.194-.194a2.916,2.916,0,0,0,3.082-.68l5.824-5.824L34.04,12.77h0a.958.958,0,0,0,.68.291.881.881,0,0,0,.68-.291l1.383-1.383a.967.967,0,0,0,0-1.383L35.229,8.45l1.723-1.723A1.317,1.317,0,0,0,37.049,4.737ZM26.565,16.92a1.91,1.91,0,0,1-2.281.34.445.445,0,0,0-.558.1l-.413.413a.228.228,0,0,1-.17.073.181.181,0,0,1-.17-.073.235.235,0,0,1,0-.34l.413-.437a.444.444,0,0,0,.073-.558,1.99,1.99,0,0,1,.34-2.281l5.824-5.824,2.742,2.742Zm9.61-6.188-1.383,1.383L28.628,5.926l1.383-1.383L31.564,6.1h0l.68.68h0L33.967,8.5h0l.68.68h0Z",
    transform: "translate(-5.964)",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11334",
    "data-name": "Path 11334",
    d: "M16.742,73.646a.469.469,0,0,0-.68,0L14.7,75a2.387,2.387,0,0,0-.7,1.7,2.307,2.307,0,0,0,.7,1.7,2.429,2.429,0,0,0,1.7.7,2.4,2.4,0,0,0,2.4-2.427,2.307,2.307,0,0,0-.7-1.7Zm.68,4.1a1.465,1.465,0,0,1-2.039,0h0a1.465,1.465,0,0,1,0-2.039L16.4,74.689l1.019,1.019a1.431,1.431,0,0,1,.413,1.019A1.518,1.518,0,0,1,17.422,77.747Z",
    transform: "translate(0 -53.183)",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPickerIcon);
export default __webpack_public_path__ + "static/media/colorPickerIcon.3c443d41516ca97ef8276d0f9be4a5e9.svg";
export { ForwardRef as ReactComponent };